import React, { useState } from 'react';
import { MdConfirmationNumber } from 'react-icons/md';

import { useFormikContext } from 'formik';

import SettingsOption from '../SettingsOption';
import MaxTicketsModal from './MaxTicketsModal';

const MaxTicketsSettings = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  const [showMaxTicketsModal, setShowMaxTicketsModal] = useState(false);

  const toggleMaxTicketsModal = () => {
    setShowMaxTicketsModal((showMaxTicketsModal) => !showMaxTicketsModal);
  };

  const onSave = (maxTicketsPerTransaction: string) => {
    setFieldValue('maxTicketsPerTransaction', maxTicketsPerTransaction);
  };

  return (
    <>
      <SettingsOption
        icon={<MdConfirmationNumber size={20} />}
        title="Max tickets per purchaser"
        actionLabel="Add max"
        value={values?.maxTicketsPerTransaction}
        onClick={toggleMaxTicketsModal}
        tooltipMessage="Set a limit for the number of tickets a guest can purchase."
      />

      {showMaxTicketsModal && (
        <MaxTicketsModal
          onClose={toggleMaxTicketsModal}
          onSave={onSave}
          initialValues={{
            maxTicketsPerTransaction: values?.maxTicketsPerTransaction || ''
          }}
        />
      )}
    </>
  );
};

export default MaxTicketsSettings;
